import { Component, OnInit, OnDestroy, HostListener, TemplateRef, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { SidebarService, ISidebar } from '../sidebar/sidebar.service';
import { Router } from '@angular/router';
import { LangService, Language } from 'src/app/shared/lang.service';
import { AuthService } from 'src/app/shared/auth.service';
import { environment } from 'src/environments/environment';
import { getThemeColor, setThemeColor } from 'src/app/utils/util';
import { BsModalService } from 'ngx-bootstrap/modal';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
})
export class TopnavComponent implements OnInit, OnDestroy {
 @ViewChild('notificationDetailModal') notificationDetailModal!: TemplateRef<any>;
  notifModalRef: any;
  selectedNotif: any = null;

  buyUrl = environment.buyUrl;
  adminRoot = environment.loginURL;
  sidebar: ISidebar;
  subscription: Subscription;
  displayName = 'Sarah Cortney';
  languages: Language[];
  currentLanguage: string;
  isSingleLang;
  isFullScreen = false;
  isDarkModeActive = false;
  searchKey = '';

  dpImage: string = "/assets/img/profiles/user.png";
  dpCompany: string = "/assets/img/profiles/user.png";

  constructor(
    private sidebarService: SidebarService,
    private authService: AuthService,
    private router: Router,
    private langService: LangService,
    private modalService: BsModalService,
    private http: HttpClient,
  ) {
    this.languages = this.langService.supportedLanguages;
    this.currentLanguage = this.langService.languageShorthand;
    this.isSingleLang = this.langService.isSingleLang;
    this.isDarkModeActive = getThemeColor().indexOf('dark') > -1 ? true : false;

    let dp = localStorage.getItem('DPImage');
    if (dp !== "null") {
      this.dpImage = dp;
    } else {
      this.dpImage = "/assets/img/profiles/user.png";
    }

    let dpLogo = localStorage.getItem('DPCompany');
    if (dpLogo !== "null") {
      this.dpCompany = dpLogo;
    } else {
      this.dpCompany = "/assets/img/profiles/user.png";
    }
  }

  onDarkModeChange(event): void {
    let color = getThemeColor();
    if (color.indexOf('dark') > -1) {
      color = color.replace('dark', 'light');
    } else if (color.indexOf('light') > -1) {
      color = color.replace('light', 'dark');
    }
    setThemeColor(color);
    setTimeout(() => {
      window.location.reload();
    }, 200);
  }

  fullScreenClick(): void {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      document.documentElement.requestFullscreen();
    }
  }

  @HostListener('document:fullscreenchange', ['$event'])
  handleFullscreen(event): void {
    this.isFullScreen = !!document.fullscreenElement;
  }

  onLanguageChange(lang): void {
    this.langService.language = lang.code;
    this.currentLanguage = this.langService.languageShorthand;
  }

  async ngOnInit(): Promise<void> {
    if (await this.authService.getUser()) {
      this.displayName = await this.authService.getUser().then((user) => {
        return user.displayName;
      });
    }
    this.subscription = this.sidebarService.getSidebar().subscribe(
      (res) => { this.sidebar = res; },
      (err) => { console.error(`An error occurred: ${err.message}`); }
    );

    this.loadNotifications();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  menuButtonClick = (
    e: { stopPropagation: () => void },
    menuClickCount: number,
    containerClassnames: string
  ) => {
    if (e) { e.stopPropagation(); }

    setTimeout(() => {
      const event = document.createEvent('HTMLEvents');
      event.initEvent('resize', false, false);
      window.dispatchEvent(event);
    }, 350);

    this.sidebarService.setContainerClassnames(
      ++menuClickCount,
      containerClassnames,
      this.sidebar.selectedMenuHasSubItems
    );
  }

  mobileMenuButtonClick = (
    event: { stopPropagation: () => void },
    containerClassnames: string
  ) => {
    if (event) { event.stopPropagation(); }
    this.sidebarService.clickOnMobileMenu(containerClassnames);
  }

  onSignOut(): void {
    this.router.navigate([this.adminRoot]);
  }

  searchKeyUp(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.search();
    } else if (event.key === 'Escape') {
      const input = document.querySelector('.mobile-view');
      if (input && input.classList) { input.classList.remove('mobile-view'); }
      this.searchKey = '';
    }
  }

  searchAreaClick(event): void { event.stopPropagation(); }

  searchClick(event): void {
    if (window.innerWidth < environment.menuHiddenBreakpoint) {
      let elem = event.target;
      if (!event.target.classList.contains('search')) {
        if (event.target.parentElement.classList.contains('search')) {
          elem = event.target.parentElement;
        } else if (event.target.parentElement.parentElement.classList.contains('search')) {
          elem = event.target.parentElement.parentElement;
        }
      }
      if (elem.classList.contains('mobile-view')) {
        this.search();
        elem.classList.remove('mobile-view');
      } else {
        elem.classList.add('mobile-view');
      }
    } else {
      this.search();
    }
    event.stopPropagation();
  }

  search(): void {
    if (this.searchKey && this.searchKey.length > 1) {
      this.router.navigate([this.adminRoot + '/#'], {
        queryParams: { key: this.searchKey.toLowerCase().trim() },
      });
      this.searchKey = '';
    }
  }

  @HostListener('document:click', ['$event'])
  handleDocumentClick(event): void {
    const input = document.querySelector('.mobile-view');
    if (input && input.classList) { input.classList.remove('mobile-view'); }
    this.searchKey = '';
  }

  listOpen() {
    localStorage.setItem('screenName', 'TO-Do List');
    this.router.navigate(['APP/application/todo']);
  }

  chatOpen() { this.router.navigate(['APP/application/chat']); }

  async openTicket() {
    localStorage.setItem('screenName', 'Ticket');
    const url = this.router.serializeUrl(this.router.createUrlTree(['APP/application/ticket']));
    window.open(url, '_blank');
  }

  modalRef: any;
  openModalAdd(template: TemplateRef<any>): void {
    this.modalRef = this.modalService.show(template);
  }
  caption: any;
  msg: string;
  modalRefMessage: any;

  @ViewChild('modalmessage') modalmessage: TemplateRef<any>;
  openModalMessage(template: TemplateRef<any>): void {
    this.modalRefMessage = this.modalService.show(template);
  }

  async Submit() {
    let password: any = document.getElementById('passwordField');
    let repassword: any = document.getElementById('repasswordField');
    let oldpassword: any = document.getElementById('oldpasswordField');

    if (password.value === "" && repassword.value === "") {
      this.caption = 'Warning';
      this.msg = 'Password and Re-Type Password is required!';
      this.openModalMessage(this.modalmessage);
    } else if (password.value === "") {
      this.caption = 'Warning';
      this.msg = 'Password is required!';
      this.openModalMessage(this.modalmessage);
    } else if (repassword.value === "") {
      this.caption = 'Warning';
      this.msg = 'Re-Type Password is required!';
      this.openModalMessage(this.modalmessage);
    } else if (oldpassword.value === "") {
      this.caption = 'Warning';
      this.msg = 'Previous Password is required!';
      this.openModalMessage(this.modalmessage);
    } else if (password.value !== repassword.value) {
      this.caption = 'Validator';
      this.msg = 'Password does not match!';
      this.openModalMessage(this.modalmessage);
    } else {
      let body = {
        userID: Number(localStorage.getItem('UserID')),
        password: password.value,
        lastPassword: oldpassword.value
      };
      let baseUrl = environment.apiUrl + 'Users/ChangePassword';
      await this.http.post(baseUrl, body).toPromise().then((user: any) => {
        if (user.message) {
          this.caption = user.message === "Password successfully changed" ? 'Success' : 'Error';
          this.msg = user.message;
          this.openModalMessage(this.modalmessage);
          if (user.message === "Password successfully changed") this.modalRef.hide();
        } else {
          this.modalRef.hide();
        }
      }).catch((error) => { this.modalRef.hide(); });
    }
  }

  show: boolean = false;
  showold: boolean = false;
  showre: boolean = false;

  textPassword() { this.show = !this.show; }
  textRePassword() { this.showre = !this.showre; }
  textoldPassword() { this.showold = !this.showold; }

  // ================= NOTIFICATIONS =================
  notifOpen = false;
  notifFilter: 'all' | 'unread' = 'all';
  notifications: any[] = [];

  toggleNotif(event: Event): void {
    event.stopPropagation();
    this.notifOpen = !this.notifOpen;
    if (this.notifOpen) {
      this.loadNotifications();   // refresh on every open
    }
  }

  closeNotif(): void { this.notifOpen = false; }

  @HostListener('document:click', ['$event'])
  closeNotifOnOutsideClick(event: MouseEvent): void {
    if (this.notifOpen) {
      const target = event.target as HTMLElement;
      if (!target.closest('.notification-wrapper')) {
        this.notifOpen = false;
      }
    }
  }

  // Load notifications from API
  loadNotifications(): void {
    const userId = Number(localStorage.getItem('UserID'));
    if (!userId) return;

    const url = `${environment.apiUrl}GL_Menu/GetNotifications?UserID=${userId}`;

    this.http.get<any[]>(url).subscribe(
      (res) => {
        this.notifications = (res || []).map((n: any) => ({
          id: n.Id,
          title: n.Title,
          message: n.Message,
          time: n.Time,
          type: n.Type,
          read: n.IsRead
        }));
      },
      (err) => {
        console.error('Failed to load notifications', err);
        this.notifications = [];
      }
    );
  }

  get unreadCount(): number {
    return this.notifications.filter(n => !n.read).length;
  }

  get filteredNotifications(): any[] {
    return this.notifFilter === 'unread'
      ? this.notifications.filter(n => !n.read)
      : this.notifications;
  }

  getNotifIcon(type: string): string {
    switch (type) {
      case 'order': return 'simple-icon-bag';
      case 'promo': return 'simple-icon-tag';
      case 'system': return 'simple-icon-bell';
      case 'chat': return 'simple-icon-bubble';
      default: return 'simple-icon-bell';
    }
  }

  setNotifFilter(filter: 'all' | 'unread'): void {
    this.notifFilter = filter;
  }

  openNotificationDetail(notif: any, event: Event): void {
    event.stopPropagation();

    const userId = Number(localStorage.getItem('UserID'));

    const url = `${environment.apiUrl}GL_Menu/GetNotificationDetail?UserID=${userId}&Id=${notif.id}`;

    this.http.get<any>(url).subscribe(
      (res: any) => {
        this.selectedNotif = {
          id: res.id ?? res.Id,
          title: res.title ?? res.Title,
          message: res.message ?? res.Message,
          time: res.time ?? res.Time,
          type: res.type ?? res.Type,
          read: res.isRead ?? res.IsRead ?? false
        };

        // Auto-mark as read in UI
        if (!this.selectedNotif.read) {
          this.markAsRead(notif);
          this.selectedNotif.read = true;
        }

        this.notifModalRef = this.modalService.show(this.notificationDetailModal, {
          class: 'modal-md modal-dialog-centered',
          backdrop: true,
          ignoreBackdropClick: false
        });
      },
      (err) => {
        console.error('Notification detail error:', err);
        this.selectedNotif = notif;
        this.notifModalRef = this.modalService.show(this.notificationDetailModal, {
          class: 'modal-md modal-dialog-centered'
        });
      }
    );
  }

  markSelectedAsRead(): void {
    if (this.selectedNotif && !this.selectedNotif.read) {
      this.markAsRead(this.selectedNotif);
      this.selectedNotif.read = true;
    }
  }

  markAsRead(notif: any): void {
    if (notif.read) return;
    notif.read = true;   // optimistic UI update

    const userId = Number(localStorage.getItem('UserID'));
    const url = `${environment.apiUrl}GL_Menu/MarkNotificationRead?UserID=${userId}&Id=${notif.id}`;
    this.http.post(url, {}).subscribe({
      error: (err) => {
        console.error('Mark read failed', err);
        notif.read = false;   // rollback on error
      }
    });
  }

  markAllAsRead(): void {
    this.notifications.forEach(n => n.read = true);

    const userId = Number(localStorage.getItem('UserID'));
    const url = `${environment.apiUrl}GL_Menu/MarkAllNotificationsRead?UserID=${userId}`;
    this.http.post(url, {}).subscribe({
      error: (err) => {
        console.error('Mark all read failed', err);
        this.loadNotifications();   // reload to reset state
      }
    });
  }
  // ================= END NOTIFICATIONS =================
}